// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"81431cc5","853":"a8082ba5"}[chunkId] + ".chunk.css";
};